module.exports = __webpack_public_path__ + "static/media/Paid.c324281a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Paid.svg
// module id = 828
// module chunks = 17